import styled from 'styled-components'

export const StyledSVG = styled.svg`
  border: none;

  g #sun-circle {
    fill: var(--decorator-secondary);
  }

  g .sun-ray {
    fill: var(--decorator-secondary);
  }
`
